import App from "@frog/source/models/App.js"
import Tiled from "@frog/source/utility/integration/Tiled.js"
import Random from "@frog/source/utility/Random.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"
import * as PlotConditions from "@frog/source/data/plot/conditions.js"
import * as PlotScripts from "@frog/source/data/plot/scripts.js"
import Navigation from "@frog/source/models/Navigation.js"
import Zone from "@frog/source/models/Zone.js"

const world = Tiled.parse({
    "tilemap": require("./tiles.json"),
    "tileset": require("@frog/source/data/levels/vmenezio.tileset.json"),
})
world.spots = require("./spots.json")

export default {
    "slug": "y4",
    "stage": {
        "image": require("./tiles.png"),
        "units": require("./units.json"),
        "world": world,
        "conditions": [
            {
                "type": "turn:0:start",
                "events": [
                    PlotSteps.PlayAudio("Music:Combat"),
                    PlotSteps.SpawnPlayerPartyScript(),
                ]
            },
            ...PlotScripts.EncounterVictories({"encounterKeys": [1, "2b", "3b", "4b", 5], "nextURL": "/games/war/chapters/y5"}),
            // ...PlotScripts.EncounterVictories({"encounterKeys": [1, ["2a", "2b"], ["3a", "3b"], ["4a", "4b"], 5], "nextURL": "/games/war"}),
            PlotScripts.ChapterFailure(),
        ]
    },
}
